import { Box, Divider, styled, Typography } from "@mui/material";
import { shouldForwardProp } from "../../../../common/Common.style";
import HomeIcon from "@mui/icons-material/Home";
import theme from "../../../../theme";

type MapMarkerProp = {
  statusColor: string;
  borderColor?: string;
};

export const AdvanceSearchMapWrapper = styled(Box)`
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .gm-style-iw-ch {
    padding: 6px !important;
  }

  .gm-ui-hover-effect {
    width: 14px !important;
    height: 14px !important;
    margin-right: 4px !important;
    padding-top: 2px !important;

    span {
      width: 16px !important;
      height: 16px !important;
      margin: 0 !important;
    }
  }
`;

export const MapPinIconWrapper = styled("div")`
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${theme.palette.common.white};
`;

export const MapPinHomeIcon = styled(HomeIcon)`
  font-size: 30px;
  color: ${theme.palette.common.white};
`;

export const MapPinContainer = styled(Box, {
  shouldForwardProp: prop =>
    shouldForwardProp<MapMarkerProp>(["statusColor", "borderColor"], prop),
})<MapMarkerProp>(({ statusColor, borderColor }) => ({
  alignItems: "center",
  background: statusColor,
  borderRadius: "50%",
  display: "flex",
  fontSize: "14px",
  gap: "15px",
  height: "40px",
  width: "40px",
  justifyContent: "center",
  padding: "4px",
  position: "relative",
  transition: "all 0.4s ease-in-out",

  "&:after": {
    borderLeft: "9px solid transparent",
    borderRight: "9px solid transparent",
    borderTop: `7px solid ${borderColor}`,
    content: '""',
    height: 0,
    left: "50%",
    position: "absolute",
    top: "95%",
    transform: "translate(-50%, 0)",
    transition: "all 0.3s ease-out",
    width: 0,
    zIndex: 1,
  },
}));

export const NearbyPatientsCount = styled(Typography)`
  font-size: 15px;
  font-weight: bold;
`;

export const PinContentStyle = styled(Box)`
  max-height: 200px;
  max-width: 320px;
`;

export const AddressWrapper = styled(Typography)`
  font-size: 15px;
`;

export const AddressText = styled("span")`
  font-weight: bold;
`;

export const AddressDivider = styled(Divider)`
  margin: 5px 0;
`;
